module.exports = __webpack_public_path__ + "static/img/image004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image004.jpg
// module id = iFlt
// module chunks = 1